/* Opens the desktop mega menu on hover instead of requiring a click.

   Gated three ways:
     - a real pointer that can hover (so touch keeps tap-to-open)
     - the desktop breakpoint, where the inline nav exists at all
     - the <details> element Dawn already uses, so click and keyboard keep
       working exactly as before

   Closing is delayed slightly. The panel is a child of the same <details>,
   but the cursor still crosses a few pixels of gap on the way down, and a
   menu that snaps shut mid-travel is worse than one that lingers. */

(function () {
  var CLOSE_DELAY = 140;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var isDesktop = window.matchMedia('(min-width: 990px)');

  function bind(host) {
    var details = host.querySelector('details');
    if (!details) return;

    var closeTimer = null;

    function open() {
      if (!canHover.matches || !isDesktop.matches) return;
      clearTimeout(closeTimer);
      if (details.open) return;

      // Only one panel at a time, same as clicking would give.
      document.querySelectorAll('.header__inline-menu details[open]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
      details.open = true;
    }

    function scheduleClose() {
      if (!canHover.matches || !isDesktop.matches) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        details.open = false;
      }, CLOSE_DELAY);
    }

    host.addEventListener('mouseenter', open);
    host.addEventListener('mouseleave', scheduleClose);

    // Keyboard users tab to the summary; treat that like a hover.
    host.addEventListener('focusin', open);
  }

  document.querySelectorAll('.header__inline-menu header-menu').forEach(bind);
})();
